// extracted by mini-css-extract-plugin
export default {"vendorsNav":"vendorsNav__YjMzN","overlay":"overlay__ODk1N","active":"active__ZDZjN"};